/*** IMPORTS FROM imports-loader ***/
var define = false;

export { default } from 'react-motion/lib/spring';



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-transition/es/spring.js
// module id = 367
// module chunks = 0